import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router";
import { request } from "utils/apiClient";

export const Debug: React.FunctionComponent = () => {
  if (!IS_DEBUG) return <Navigate to={{ pathname: "/" }} />;

  return (
    <Routes>
      <Route path="logout" element={<Logout />} />
    </Routes>
  );
};

const Logout: React.FunctionComponent = () => {
  const [isLogout, setIsLogout] = useState(false);

  useEffect(() => {
    request("/logout").then(() => setIsLogout(true));
  }, []);

  const style: React.CSSProperties = {
    width: "100%",
    textAlign: "center",
    marginTop: "100px",
    fontSize: "24px"
  };
  const message = isLogout ? "ログアウトしました" : "ログアウト中です...";
  return <div style={style}>{message}</div>;
};
